module.exports = __webpack_public_path__ + "img/dong.7b23a17e.gif";